<template>
  <ModalBase :show-modal="true" @close-modal="close" short auto-h class="gk-modal-confirm">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal title-modal--simple">
        <template v-slot:title>
          {{ $gettext('Payment Link') }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <p v-translate>
        You need a Mollie account to send payment links. Please <span class="emphasize">integrate Mollie with Gekko by clicking the 'Get started' button below. </span> If you don't have a Mollie account yet just follow the steps to signup after pressing 'Get started'.
      </p>
    </template>
    <template v-slot:actions>
      <div class="d-flex justify-content-between align-items-center w-100">
        <GekkoButton
          :href="Urls['accounts_ideal_payment_settings']()"
          :text="$gettext('My Mollie settings')"
          variant="link"
          class="px-0"
        />
        <div>
          <GekkoButton
            @click="close()"
            :text="$gettext('Cancel')"
            variant="light"
            class="mr-2"
          />
          <GekkoButton
            @click="connectToMollie()"
            :text="$gettext('Get started')"
            icon="fa-solid fa-plug"
          />
        </div>
      </div>
    </template>
  </ModalBase>
</template>

<script>
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import ModalBase from "@/components/base_components/ModalBase";

export default {
  name: 'MollieNoProfileModal',
  components: {
    TitleBar,
    GekkoButton,
    ModalBase,
  },
  methods: {
    close () {
      this.$emit('close')
    },
    connectToMollie () {
      console.log('connectToMollie')
    }
  },
}
</script>

<style lang="scss" scoped>

</style>